
import Vue from "vue";
import { Motd } from "@/models/motd";
import { MotdService } from "@/services/motd-service";
import { IDataTableColumn } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			motds: [] as Motd[],
			selectedItems: [] as Motd[]
		};
	},
	computed: {
		deleteDisabled():boolean {
			return this.selectedItems.length == 0;
		},
		editLink():string{
			if (this.selectedItems.length != 1) return "";
			return `/motd/edit/${this.selectedItems[0].id}`;
		},
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					width: "50px"
				},
				{
					name: "Message",
					property: "translations.nl-be",
					width: "200px"
				},
				{
					name: "Expiration Date",
					property: "expirationDate",
					print(val:Date):string{
						return val.toLocaleDateString("nl-be");
					}
				}
			];
		}
	},
	methods: {
		deleteMotds(){
			for (let motd of this.selectedItems){
				MotdService.deleteMotd(motd).then(()=>{
					this.selectedItems.splice(this.selectedItems.indexOf(motd), 1);
					this.motds.splice(this.motds.indexOf(motd), 1);
				});
			}
		}
	},
	async mounted(){
		this.motds = await MotdService.getUpcommingMotds();
	}

});
